import React from 'react';
import { motion } from 'framer-motion';
import { CloudRainIcon, BatteryWarningIcon, SearchXIcon, FrownIcon, CompassIcon } from 'lucide-react';
import { staggerContainer, fadeUp } from '../utils/animations';
const painPoints = [{
  text: 'Falta de motivación',
  icon: BatteryWarningIcon
}, {
  text: 'Tristeza constante',
  icon: CloudRainIcon
}, {
  text: 'Sensación de vacío',
  icon: SearchXIcon
}, {
  text: 'Dificultad para concentrarte',
  icon: CompassIcon
}, {
  text: 'Pérdida de interés por las cosas',
  icon: FrownIcon
}];
export function ProblemSection() {
  return <section className="relative py-28 md:py-32 px-4 overflow-hidden" data-id="element-203">
      {/* Background Image */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-204">
        <img src="https://cdn.magicpatterns.com/uploads/uB9ZY93CBEJB5usPDQ2AUv/13_mar_2026,_11_51_55_p.m..png" alt="" className="w-full h-full object-cover" data-id="element-205" />
        <div className="absolute inset-0 bg-white/80" data-id="element-206"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-207">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="text-center mb-20" data-id="element-208">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-serif text-[#2F3A3D] mb-6" data-id="element-209">
            ¿Te sientes así?
          </h2>
        </motion.div>

        <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20 justify-center" data-id="element-210">
          {painPoints.map((point, index) => {
          const Icon = point.icon;
          return <motion.div key={index} variants={fadeUp} className={`flex items-center p-8 rounded-3xl bg-[#F7F3E9] border border-[#E8E1D5] shadow-[0_10px_30px_rgba(47,58,61,0.04)] ${index === 3 ? 'md:col-span-1 lg:col-start-2' : ''} ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-211">
                <div className="flex-shrink-0 mr-5" data-id="element-212">
                  <div className="w-14 h-14 rounded-2xl bg-white flex items-center justify-center shadow-sm border border-[#E8E1D5]" data-id="element-213">
                    <Icon className="w-7 h-7 text-[#F4A261]" data-id="element-214" />
                  </div>
                </div>
                <p className="text-lg text-[#2F3A3D] font-medium leading-tight" data-id="element-215">
                  {point.text}
                </p>
              </motion.div>;
        })}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-center space-y-6" data-id="element-216">
          <p className="text-3xl md:text-4xl font-serif text-[#F4A261] italic" data-id="element-217">
            No estás solo. Miles de personas pasan por lo mismo.
          </p>
          <p className="text-xl text-[#5F6368] max-w-2xl mx-auto leading-relaxed" data-id="element-218">
            Este ebook fue creado para ayudarte a encontrar una salida.
          </p>
        </motion.div>
      </div>
    </section>;
}